import { noteListSchema, type NoteItem } from '@personal-os/shared';

export const NOTES_KEY = ['scratch-notes'];

export async function fetchNotes(): Promise<NoteItem[]> {
  const res = await fetch('/api/scratch/notes', { credentials: 'same-origin', cache: 'no-store' });
  if (!res.ok) throw new Error(`notes: ${res.status}`);
  return noteListSchema.parse(await res.json()).notes;
}
